module.exports = "/_next/static/images/ImproveYourAds@2x-ad228fb5a121e8f97ca2e0526a0af582.webp";